import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import ExcelBulkDeliveryDispatchModal from '../../../../views/order/common/modal/ExcelBulkDeliveryDispatchModal';
import { orderActions } from '../../../../store/modules/order';
import withModal from '../../../../lib/hoc/withModal';

class ExcelBulkDeliveryDispatchModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      file: null,
    };
  }

  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'excelBulkDeliveryDispatchModal',
    });
  };

  onSubmit = () => {
    const { checkExcelBulkDeliveryDispatch } = this.props;
    const { file } = this.state;

    if (!file) {
      message.error('업로드할 파일을 선택해 주세요.');
      return;
    }

    checkExcelBulkDeliveryDispatch({
      attachment: [file],
    });

    this.closeModal();
  };

  /**
   * 엑셀 파일 변경시 callback
   */
  onChange = (file) => {
    this.setState({
      file,
    });
  };

  render() {
    const { isOpen, data } = this.props;

    return (
      <ExcelBulkDeliveryDispatchModal
        isOpen={isOpen}
        data={data}
        {...this.state}
        onChange={this.onChange}
        onSubmit={this.onSubmit}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.excelBulkDeliveryDispatchModal.isOpen,
    data: state.order.excelBulkDeliveryDispatchModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  checkExcelBulkDeliveryDispatch: orderActions.checkExcelBulkDeliveryDispatch,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(ExcelBulkDeliveryDispatchModalContainer));
